webpackJsonp([12],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setTranslations = setTranslations;
exports.getTranslations = getTranslations;
var translations = {};

function setTranslations(t) {
    Object.assign(translations, t);
}

function getTranslations() {
    return translations;
}

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateTimeToolTip = function (_React$Component) {
    _inherits(DateTimeToolTip, _React$Component);

    function DateTimeToolTip() {
        _classCallCheck(this, DateTimeToolTip);

        return _possibleConstructorReturn(this, (DateTimeToolTip.__proto__ || Object.getPrototypeOf(DateTimeToolTip)).apply(this, arguments));
    }

    _createClass(DateTimeToolTip, [{
        key: 'getDateFormat',
        value: function getDateFormat(format) {
            var formats = {
                long: {
                    weekday: 'short',
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: false,
                    timeZoneName: 'short'
                },
                short: {
                    weekday: 'numeric',
                    day: 'numeric',
                    month: 'numeric'
                }
            };

            return formats.hasOwnProperty(format) ? formats[format] : formats.long;
        }
    }, {
        key: 'getDateString',
        value: function getDateString() {
            var date = new Date(this.props.date);

            if (window.Intl) {
                // Temporary try catch to help debug: https://app.bugsnag.com/99designs/contests-js/errors/57bbef5550ddfc58161c042a
                // FIXME: Daniel Williams - remove bugsnag logging and try..catch
                // when bug resolved
                try {
                    return Intl.DateTimeFormat(this.context.locales, this.getDateFormat(this.props.format)).format(date);
                } catch (e) {
                    if (window.Bugsnag) {
                        var errorMetaData = {
                            special_info: {
                                locales: this.context.locales,
                                date: date,
                                dateProp: this.props.date,
                                format: this.props.format
                            }
                        };

                        window.Bugsnag.notifyException(e, "DateTimeToolTip error", errorMetaData, "error");
                    }

                    return "";
                }
            } else {
                return '';
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'span',
                { title: this.getDateString() },
                this.props.children
            );
        }
    }]);

    return DateTimeToolTip;
}(_react2.default.Component);

exports.default = DateTimeToolTip;


DateTimeToolTip.propTypes = {
    date: _propTypes2.default.any.isRequired,
    format: _propTypes2.default.oneOf(['long', 'short'])
};

DateTimeToolTip.defaultProps = {
    format: 'long'
};

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = bemComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function bemComponent(baseClassName) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Block';

    var BemComponent = function (_React$Component) {
        _inherits(BemComponent, _React$Component);

        function BemComponent() {
            _classCallCheck(this, BemComponent);

            return _possibleConstructorReturn(this, (BemComponent.__proto__ || Object.getPrototypeOf(BemComponent)).apply(this, arguments));
        }

        _createClass(BemComponent, [{
            key: 'render',
            value: function render() {
                var props = Object.assign({}, this.props);
                props.className = props.className || '';
                if (props.variations) {
                    props.variations.forEach(function (v) {
                        props.className += ' ' + baseClassName + '--' + v;
                    });
                }

                props.className = baseClassName + ' ' + props.className;
                delete props.children;
                delete props.variations;

                return _react2.default.createElement(
                    'div',
                    props,
                    this.props.children
                );
            }
        }]);

        return BemComponent;
    }(_react2.default.Component);

    ;

    BemComponent.displayName = displayName;

    return BemComponent;
}

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* global window:false */
exports.default = {
    notify: function notify(errorName, errorMessage, metaData, severity) {
        if (!window.Bugsnag) {
            return console.error(errorName, errorMessage, metaData); // eslint-disable-line
        }
        window.Bugsnag.notify(errorName, errorMessage, metaData, severity);
    }
};

/***/ }),

/***/ 1487:
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["MediaQuery"] = factory(require("react"));
	else
		root["MediaQuery"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_8__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (true) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(9)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require('./factoryWithThrowingShims')();
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (true) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (true) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);

// properties that match media queries
var matchers = {
  orientation: _propTypes2.default.oneOf(['portrait', 'landscape']),

  scan: _propTypes2.default.oneOf(['progressive', 'interlace']),

  aspectRatio: _propTypes2.default.string,
  deviceAspectRatio: _propTypes2.default.string,

  height: stringOrNumber,
  deviceHeight: stringOrNumber,

  width: stringOrNumber,
  deviceWidth: stringOrNumber,

  color: _propTypes2.default.bool,

  colorIndex: _propTypes2.default.bool,

  monochrome: _propTypes2.default.bool,
  resolution: stringOrNumber

  // media features
};var features = _extends({
  minAspectRatio: _propTypes2.default.string,
  maxAspectRatio: _propTypes2.default.string,
  minDeviceAspectRatio: _propTypes2.default.string,
  maxDeviceAspectRatio: _propTypes2.default.string,

  minHeight: stringOrNumber,
  maxHeight: stringOrNumber,
  minDeviceHeight: stringOrNumber,
  maxDeviceHeight: stringOrNumber,

  minWidth: stringOrNumber,
  maxWidth: stringOrNumber,
  minDeviceWidth: stringOrNumber,
  maxDeviceWidth: stringOrNumber,

  minColor: _propTypes2.default.number,
  maxColor: _propTypes2.default.number,

  minColorIndex: _propTypes2.default.number,
  maxColorIndex: _propTypes2.default.number,

  minMonochrome: _propTypes2.default.number,
  maxMonochrome: _propTypes2.default.number,

  minResolution: stringOrNumber,
  maxResolution: stringOrNumber

}, matchers);

// media types
var types = {
  all: _propTypes2.default.bool,
  grid: _propTypes2.default.bool,
  aural: _propTypes2.default.bool,
  braille: _propTypes2.default.bool,
  handheld: _propTypes2.default.bool,
  print: _propTypes2.default.bool,
  projection: _propTypes2.default.bool,
  screen: _propTypes2.default.bool,
  tty: _propTypes2.default.bool,
  tv: _propTypes2.default.bool,
  embossed: _propTypes2.default.bool
};

var all = _extends({}, types, features);

// add the type property
matchers.type = Object.keys(types);

exports.default = {
  all: all,
  types: types,
  matchers: matchers,
  features: features
};
module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toQuery = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(8);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matchmediaquery = __webpack_require__(12);

var _matchmediaquery2 = _interopRequireDefault(_matchmediaquery);

var _hyphenateStyleName = __webpack_require__(5);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _mediaQuery = __webpack_require__(6);

var _mediaQuery2 = _interopRequireDefault(_mediaQuery);

var _toQuery = __webpack_require__(14);

var _toQuery2 = _interopRequireDefault(_toQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultTypes = {
  component: _propTypes2.default.node,
  query: _propTypes2.default.string,
  values: _propTypes2.default.shape(_mediaQuery2.default.matchers),
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  onChange: _propTypes2.default.func,
  onBeforeChange: _propTypes2.default.func
};
var mediaKeys = Object.keys(_mediaQuery2.default.all);
var excludedQueryKeys = Object.keys(defaultTypes);
var excludedPropKeys = excludedQueryKeys.concat(mediaKeys);

function omit(object, keys) {
  var newObject = _extends({}, object);
  keys.forEach(function (key) {
    return delete newObject[key];
  });
  return newObject;
}

var MediaQuery = function (_React$Component) {
  _inherits(MediaQuery, _React$Component);

  function MediaQuery() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MediaQuery);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MediaQuery.__proto__ || Object.getPrototypeOf(MediaQuery)).call.apply(_ref, [this].concat(args))), _this), _this.state = { matches: false }, _this.updateMatches = function () {
      if (_this._mql.matches === _this.state.matches) {
        return;
      }
      _this.setState({
        matches: _this._mql.matches
      });
    }, _this.removeMql = function () {
      if (_this._mql) {
        _this._mql.removeListener(_this.updateMatches);
        _this._mql.dispose();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MediaQuery, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateQuery(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.updateQuery(nextProps);
    }
  }, {
    key: 'updateQuery',
    value: function updateQuery(props) {
      var values = void 0;
      if (props.query) {
        this.query = props.query;
      } else {
        this.query = (0, _toQuery2.default)(omit(props, excludedQueryKeys));
      }

      if (!this.query) {
        throw new Error('Invalid or missing MediaQuery!');
      }

      if (props.values) {
        values = Object.keys(props.values).reduce(function (result, key) {
          result[(0, _hyphenateStyleName2.default)(key)] = props.values[key];
          return result;
        }, {});
      }

      this.removeMql();

      this._mql = (0, _matchmediaquery2.default)(this.query, values);
      this._mql.addListener(this.updateMatches);
      this.updateMatches();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(_, nextState) {
      if (this.props.onBeforeChange && this.state.matches !== nextState.matches) {
        this.props.onBeforeChange(this.state.matches);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_, prevState) {
      if (this.props.onChange && prevState.matches !== this.state.matches) {
        this.props.onChange(this.state.matches);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeMql();
    }
  }, {
    key: 'render',
    value: function render() {
      if (typeof this.props.children === 'function') {
        return this.props.children(this.state.matches);
      }

      if (this.state.matches === false) {
        return null;
      }
      var props = omit(this.props, excludedPropKeys);
      var hasMergeProps = Object.keys(props).length > 0;
      var childrenCount = _react2.default.Children.count(this.props.children);
      var wrapChildren = this.props.component || childrenCount > 1 || typeof this.props.children === 'string' || Array.isArray(this.props.children) && childrenCount == 1 || this.props.children === undefined;
      if (wrapChildren) {
        return _react2.default.createElement(this.props.component || 'div', props, this.props.children);
      } else if (hasMergeProps) {
        return _react2.default.cloneElement(this.props.children, props);
      } else if (childrenCount) {
        return this.props.children;
      } else {
        return null;
      }
    }
  }]);

  return MediaQuery;
}(_react2.default.Component);

MediaQuery.displayName = 'MediaQuery';
MediaQuery.defaultProps = {
  values: {}
};
exports.default = MediaQuery;
exports.toQuery = _toQuery2.default;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(3);
var assign = __webpack_require__(10);

var ReactPropTypesSecret = __webpack_require__(4);
var checkPropTypes = __webpack_require__(11);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (true) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if ("development" !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       true ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       true ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (true) {
  var invariant = __webpack_require__(2);
  var warning = __webpack_require__(3);
  var ReactPropTypesSecret = __webpack_require__(4);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (true) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var staticMatch = __webpack_require__(13).match;
var dynamicMatch = typeof window !== 'undefined' ? window.matchMedia : null;

// our fake MediaQueryList
function Mql(query, values){
  var self = this;
  if(dynamicMatch){
    var mql = dynamicMatch.call(window, query);
    this.matches = mql.matches;
    this.media = mql.media;
    // TODO: is there a time it makes sense to remove this listener?
    mql.addListener(update);
  } else {
    this.matches = staticMatch(query, values);
    this.media = query;
  }

  this.addListener = addListener;
  this.removeListener = removeListener;
  this.dispose = dispose;

  function addListener(listener){
    if(mql){
      mql.addListener(listener);
    }
  }

  function removeListener(listener){
    if(mql){
      mql.removeListener(listener);
    }
  }

  // update ourselves!
  function update(evt){
    self.matches = evt.matches;
    self.media = evt.media;
  }

  function dispose(){
    if(mql){
      mql.removeListener(update);
    }
  }
}

function matchMedia(query, values){
  return new Mql(query, values);
}

module.exports = matchMedia;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/



exports.match = matchQuery;
exports.parse = parseQuery;

// -----------------------------------------------------------------------------

var RE_MEDIA_QUERY     = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i,
    RE_MQ_EXPRESSION   = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/,
    RE_MQ_FEATURE      = /^(?:(min|max)-)?(.+)/,
    RE_LENGTH_UNIT     = /(em|rem|px|cm|mm|in|pt|pc)?$/,
    RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;

function matchQuery(mediaQuery, values) {
    return parseQuery(mediaQuery).some(function (query) {
        var inverse = query.inverse;

        // Either the parsed or specified `type` is "all", or the types must be
        // equal for a match.
        var typeMatch = query.type === 'all' || values.type === query.type;

        // Quit early when `type` doesn't match, but take "not" into account.
        if ((typeMatch && inverse) || !(typeMatch || inverse)) {
            return false;
        }

        var expressionsMatch = query.expressions.every(function (expression) {
            var feature  = expression.feature,
                modifier = expression.modifier,
                expValue = expression.value,
                value    = values[feature];

            // Missing or falsy values don't match.
            if (!value) { return false; }

            switch (feature) {
                case 'orientation':
                case 'scan':
                    return value.toLowerCase() === expValue.toLowerCase();

                case 'width':
                case 'height':
                case 'device-width':
                case 'device-height':
                    expValue = toPx(expValue);
                    value    = toPx(value);
                    break;

                case 'resolution':
                    expValue = toDpi(expValue);
                    value    = toDpi(value);
                    break;

                case 'aspect-ratio':
                case 'device-aspect-ratio':
                case /* Deprecated */ 'device-pixel-ratio':
                    expValue = toDecimal(expValue);
                    value    = toDecimal(value);
                    break;

                case 'grid':
                case 'color':
                case 'color-index':
                case 'monochrome':
                    expValue = parseInt(expValue, 10) || 1;
                    value    = parseInt(value, 10) || 0;
                    break;
            }

            switch (modifier) {
                case 'min': return value >= expValue;
                case 'max': return value <= expValue;
                default   : return value === expValue;
            }
        });

        return (expressionsMatch && !inverse) || (!expressionsMatch && inverse);
    });
}

function parseQuery(mediaQuery) {
    return mediaQuery.split(',').map(function (query) {
        query = query.trim();

        var captures    = query.match(RE_MEDIA_QUERY),
            modifier    = captures[1],
            type        = captures[2],
            expressions = captures[3] || '',
            parsed      = {};

        parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
        parsed.type    = type ? type.toLowerCase() : 'all';

        // Split expressions into a list.
        expressions = expressions.match(/\([^\)]+\)/g) || [];

        parsed.expressions = expressions.map(function (expression) {
            var captures = expression.match(RE_MQ_EXPRESSION),
                feature  = captures[1].toLowerCase().match(RE_MQ_FEATURE);

            return {
                modifier: feature[1],
                feature : feature[2],
                value   : captures[2]
            };
        });

        return parsed;
    });
}

// -- Utilities ----------------------------------------------------------------

function toDecimal(ratio) {
    var decimal = Number(ratio),
        numbers;

    if (!decimal) {
        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
        decimal = numbers[1] / numbers[2];
    }

    return decimal;
}

function toDpi(resolution) {
    var value = parseFloat(resolution),
        units = String(resolution).match(RE_RESOLUTION_UNIT)[1];

    switch (units) {
        case 'dpcm': return value / 2.54;
        case 'dppx': return value * 96;
        default    : return value;
    }
}

function toPx(length) {
    var value = parseFloat(length),
        units = String(length).match(RE_LENGTH_UNIT)[1];

    switch (units) {
        case 'em' : return value * 16;
        case 'rem': return value * 16;
        case 'cm' : return value * 96 / 2.54;
        case 'mm' : return value * 96 / 2.54 / 10;
        case 'in' : return value * 96;
        case 'pt' : return value * 72;
        case 'pc' : return value * 72 / 12;
        default   : return value;
    }
}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (obj) {
  var rules = [];
  Object.keys(_mediaQuery2.default.all).forEach(function (k) {
    var v = obj[k];
    if (v != null) {
      rules.push(keyVal(k, v));
    }
  });
  return join(rules);
};

var _hyphenateStyleName = __webpack_require__(5);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

var _mediaQuery = __webpack_require__(6);

var _mediaQuery2 = _interopRequireDefault(_mediaQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var negate = function negate(cond) {
  return 'not ' + cond;
};

function keyVal(k, v) {
  var realKey = (0, _hyphenateStyleName2.default)(k);

  // px shorthand
  if (typeof v === 'number') {
    v = v + 'px';
  }
  if (v === true) {
    return k;
  }
  if (v === false) {
    return negate(k);
  }
  return '(' + realKey + ': ' + v + ')';
}

function join(conds) {
  return conds.join(' and ');
}

module.exports = exports['default'];

/***/ })
/******/ ]);
});
//# sourceMappingURL=react-responsive.js.map

/***/ }),

/***/ 1527:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(838);


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = propertyOrNull;
// Safely get property that might not exist from object that might not exist
function propertyOrNull(obj) {
    for (var _len = arguments.length, props = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        props[_key - 1] = arguments[_key];
    }

    return props.reduce(function (obj, property) {
        if (obj) {
            return obj[property] !== undefined ? obj[property] : null;
        } else {
            return null;
        }
    }, obj);
}

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Spinner = function (_React$Component) {
    _inherits(Spinner, _React$Component);

    function Spinner() {
        _classCallCheck(this, Spinner);

        return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
    }

    _createClass(Spinner, [{
        key: 'render',
        value: function render() {
            var classes = (0, _app.getComponentClasses)('spinner', this.props.variations);

            return _react2.default.createElement('div', { className: classes });
        }
    }]);

    return Spinner;
}(_react2.default.Component);

exports.default = Spinner;


Spinner.propTypes = {
    variations: _propTypes2.default.array
};

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = hasDimensions;
function hasDimensions(obj) {
    return parseInt(obj.height, 10) > 0 && parseInt(obj.width, 10) > 0;
}

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(36);
var requestBase = __webpack_require__(43);
var isObject = __webpack_require__(20);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = module.exports = __webpack_require__(44).bind(null, Request);

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only verison of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

 request.serializeObject = serialize;

 /**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'application/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

 request.serialize = {
   'application/x-www-form-urlencoded': serialize,
   'application/json': JSON.stringify
 };

 /**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  lines.pop(); // trailing CRLF

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  return /[\/+]json\b/.test(mime);
}

/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function type(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function params(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */),
        key = parts.shift(),
        val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req, options) {
  options = options || {};
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  this._setStatusProperties(this.xhr.status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);
  this.body = this.req.method != 'HEAD'
    ? this._parseBody(this.text ? this.text : this.xhr.response)
    : null;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

Response.prototype.get = function(field){
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

Response.prototype._setHeaderProperties = function(header){
  // content-type
  var ct = this.header['content-type'] || '';
  this.type = type(ct);

  // params
  var obj = params(ct);
  for (var key in obj) this[key] = obj[key];
};

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str){
  var parse = request.parse[this.type];
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

Response.prototype._setStatusProperties = function(status){
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }

  var type = status / 100 | 0;

  // status / class
  this.status = this.statusCode = status;
  this.statusType = type;

  // basics
  this.info = 1 == type;
  this.ok = 2 == type;
  this.clientError = 4 == type;
  this.serverError = 5 == type;
  this.error = (4 == type || 5 == type)
    ? this.toError()
    : false;

  // sugar
  this.accepted = 202 == status;
  this.noContent = 204 == status;
  this.badRequest = 400 == status;
  this.unauthorized = 401 == status;
  this.notAcceptable = 406 == status;
  this.notFound = 404 == status;
  this.forbidden = 403 == status;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
      // issue #876: return the http status code if the response parsing fails
      err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (res.status < 200 || res.status >= 300) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
        new_err.original = err;
        new_err.response = res;
        new_err.status = res.status;
      }
    } catch(e) {
      new_err = e; // #985 touching res may cause INVALID_STATE_ERR on old Android
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `requestBase`.
 */

Emitter(Request.prototype);
for (var key in requestBase) {
  Request.prototype[key] = requestBase[key];
}

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set responseType to `val`. Presently valid responseTypes are 'blob' and
 * 'arraybuffer'.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} pass
 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (!options) {
    options = {
      type: 'basic'
    }
  }

  switch (options.type) {
    case 'basic':
      var str = btoa(user + ':' + pass);
      this.set('Authorization', 'Basic ' + str);
    break;

    case 'auto':
      this.username = user;
      this.password = pass;
    break;
  }
  return this;
};

/**
* Add query-string `val`.
*
* Examples:
*
*   request.get('/shoes')
*     .query('size=10')
*     .query({ color: 'blue' })
*
* @param {Object|String} val
* @return {Request} for chaining
* @api public
*/

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `filename`.
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String} filename
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, filename){
  this._getFormData().append(field, file, filename || file.name);
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  var fn = this._callback;
  this.clearTimeout();
  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

Request.prototype._timeoutError = function(){
  var timeout = this._timeout;
  var err = new Error('timeout of ' + timeout + 'ms exceeded');
  err.timeout = timeout;
  this.callback(err);
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */

Request.prototype._appendQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += ~this.url.indexOf('?')
      ? '&' + query
      : '?' + query;
  }
};

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  var self = this;
  var xhr = this.xhr = request.getXHR();
  var timeout = this._timeout;
  var data = this._formData || this._data;

  // store callback
  this._callback = fn || noop;

  // state change
  xhr.onreadystatechange = function(){
    if (4 != xhr.readyState) return;

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (0 == status) {
      if (self.timedout) return self._timeoutError();
      if (self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  }
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // timeout
  if (timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self.timedout = true;
      self.abort();
    }, timeout);
  }

  // querystring
  this._appendQueryString();

  // initiate request
  if (this.username && this.password) {
    xhr.open(this.method, this.url, true, this.username, this.password);
  } else {
    xhr.open(this.method, this.url, true);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;
    xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};


/**
 * Expose `Request`.
 */

request.Request = Request;

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn){
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn){
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn){
  var req = request('OPTIONS', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, fn){
  var req = request('DELETE', url);
  if (fn) req.end(fn);
  return req;
};

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn){
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn){
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn){
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deprecated;
function deprecated(message) {
    if (false) {
        console.warn('DEPRECATED: ' + message);
    }
}

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = assignProps;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function assignProps(Component, props) {
    var AssignProps = function (_React$Component) {
        _inherits(AssignProps, _React$Component);

        function AssignProps() {
            _classCallCheck(this, AssignProps);

            return _possibleConstructorReturn(this, (AssignProps.__proto__ || Object.getPrototypeOf(AssignProps)).apply(this, arguments));
        }

        _createClass(AssignProps, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(Component, _extends({}, props, this.props));
            }
        }]);

        return AssignProps;
    }(_react2.default.Component);

    ;

    AssignProps.displayName = 'assignProps(' + (Component.displayName || Component.name) + ')';

    return AssignProps;
}

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getComponentClasses;
function getComponentClasses(baseClass) {
    var variations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var result = baseClass;

    if (variations.length) {
        variations.forEach(function (name) {
            result += " " + baseClass + "--" + name;
        });
    }

    return result;
};

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = functionOrFalse;
function functionOrFalse(props, propName) {
    if (props[propName] === false || typeof props[propName] === 'function') {
        return;
    } else {
        return new Error('Prop ' + propName + ' expected to be a function, or false');
    }
}

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assignProps = __webpack_require__(29);

Object.defineProperty(exports, 'assignProps', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_assignProps).default;
  }
});

var _bemComponent = __webpack_require__(13);

Object.defineProperty(exports, 'bemComponent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bemComponent).default;
  }
});

var _functionOrFalse = __webpack_require__(31);

Object.defineProperty(exports, 'functionOrFalse', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_functionOrFalse).default;
  }
});

var _getComponentClasses = __webpack_require__(30);

Object.defineProperty(exports, 'getComponentClasses', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getComponentClasses).default;
  }
});

var _propertyOrNull = __webpack_require__(17);

Object.defineProperty(exports, 'propertyOrNull', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_propertyOrNull).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getDimensionsConstrainedToContainer;
function getDimensionsConstrainedToContainer(elementDimensions, containerDimensions) {
    var widthScale;
    var heightScale;
    var scale;

    if (elementDimensions.width < containerDimensions.width && elementDimensions.height < containerDimensions.height) {
        return elementDimensions;
    }

    widthScale = containerDimensions.width / elementDimensions.width;
    heightScale = containerDimensions.height / elementDimensions.height;
    scale = Math.min(widthScale, heightScale);

    return {
        width: parseInt(elementDimensions.width * scale, 10),
        height: parseInt(elementDimensions.height * scale, 10)
    };
}

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getDimensionsConstrainedToContainerWidth;
function getDimensionsConstrainedToContainerWidth(elementDimensions, containerDimensions) {
    var newDimensions = {
        width: containerDimensions.width,
        height: parseInt(containerDimensions.width / elementDimensions.width * elementDimensions.height, 10)
    };

    return containerDimensions.width > elementDimensions.width ? elementDimensions : newDimensions;
}

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getLinkTargetPath;
function getLinkTargetPath(node) {
    var href = node.getAttribute('href');

    if (href && href.match(/^http/)) {
        return href.replace(/^http[s]{0,1}:\/\/.[^\/]+[\/]*/, '/');
    }

    return href;
}

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getLinkTargetUrl;
function getLinkTargetUrl(node) {
    var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;

    var href = node.getAttribute('href');
    var origin = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');

    if (href && !href.match(/^http/)) {
        return '' + origin + href;
    }

    return href;
}

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getDimensionsConstrainedToContainer = __webpack_require__(412);

Object.defineProperty(exports, 'getDimensionsConstrainedToContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDimensionsConstrainedToContainer).default;
  }
});

var _getDimensionsConstrainedToContainerWidth = __webpack_require__(413);

Object.defineProperty(exports, 'getDimensionsConstrainedToContainerWidth', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDimensionsConstrainedToContainerWidth).default;
  }
});

var _hasDimensions = __webpack_require__(221);

Object.defineProperty(exports, 'hasDimensions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_hasDimensions).default;
  }
});

var _getLinkTargetPath = __webpack_require__(414);

Object.defineProperty(exports, 'getLinkTargetPath', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getLinkTargetPath).default;
  }
});

var _getLinkTargetUrl = __webpack_require__(415);

Object.defineProperty(exports, 'getLinkTargetUrl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getLinkTargetUrl).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(20);

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

exports.clearTimeout = function _clearTimeout(){
  this._timeout = 0;
  clearTimeout(this._timer);
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

exports.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

exports.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeout to `ms`.
 *
 * @param {Number} ms
 * @return {Request} for chaining
 * @api public
 */

exports.timeout = function timeout(ms){
  this._timeout = ms;
  return this;
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} reject
 * @return {Request}
 */

exports.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject){
      self.end(function(err, res){
        if (err) innerReject(err); else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
}

exports.catch = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

exports.use = function use(fn) {
  fn(this);
  return this;
}


/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

exports.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

exports.getHeader = exports.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

exports.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
exports.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
exports.field = function(name, val) {

  // name should be either a string or an object.
  if (null === name ||  undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
exports.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

exports.withCredentials = function(){
  // This is browser-only functionality. Node side is no-op.
  this._withCredentials = true;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

exports.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

exports.toJSON = function(){
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * TODO: future proof, move to compoent land
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

exports._isHost = function _isHost(obj) {
  var str = {}.toString.call(obj);

  switch (str) {
    case '[object File]':
    case '[object Blob]':
    case '[object FormData]':
      return true;
    default:
      return false;
  }
}

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

exports.send = function(data){
  var obj = isObject(data);
  var type = this._header['content-type'];

  // merge
  if (obj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!obj || this._isHost(data)) return this;

  // default to json
  if (!type) this.type('json');
  return this;
};


/***/ }),

/***/ 44:
/***/ (function(module, exports) {

// The node and browser modules expose versions of this with the
// appropriate constructor function bound as first argument
/**
 * Issue a request:
 *
 * Examples:
 *
 *    request('GET', '/users').end(callback)
 *    request('/users').end(callback)
 *    request('/users', callback)
 *
 * @param {String} method
 * @param {String|Function} url or callback
 * @return {Request}
 * @api public
 */

function request(RequestConstructor, method, url) {
  // callback
  if ('function' == typeof url) {
    return new RequestConstructor('GET', method).end(url);
  }

  // url first
  if (2 == arguments.length) {
    return new RequestConstructor('GET', method);
  }

  return new RequestConstructor(method, url);
}

module.exports = request;


/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(916)();
}


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = trackEvent;
//
// Segment analytics event tracking that includes experiment data.
//
// https://segment.com/docs/libraries/analytics.js/
//
function trackEvent(event) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var callback = arguments[3];

    var trackParams = window.trackParams || {};

    params = _extends({
        url: window.location.href
    }, trackParams, params);

    if (false) {
        console.info('Track event: "%s": %o', event, params); // eslint-disable-line no-console
    }

    if (window.analytics) {
        window.analytics.track(event, params, options, callback);
    } else {
        if (typeof callback == 'function') {
            callback();
        }
    }
}

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),

/***/ 838:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _brandContainer = __webpack_require__(943);

var _brandContainer2 = _interopRequireDefault(_brandContainer);

var _globalnav = __webpack_require__(954);

var _globalnav2 = _interopRequireDefault(_globalnav);

__webpack_require__(133);

__webpack_require__(978);

__webpack_require__(161);

__webpack_require__(929);

__webpack_require__(231);

__webpack_require__(492);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Initialise asimov-media-query-label outside dom ready check below. It has its own check and we want
// this to fire early on.
(0, _jquery2.default)(document).mediaQueryLabel();

(0, _jquery2.default)(function () {
    // activate relative date stamps
    (0, _jquery2.default)('span.gmttime').dateTime(false);

    document.addEventListener('uiNeedsTimeUpdate', function () {
        (0, _jquery2.default)('span.gmttime').dateTime(true);
    });

    // update relative time every minute to provide a countdown
    setInterval(function () {
        document.dispatchEvent(new CustomEvent('uiNeedsTimeUpdate'));
    }, 60000);

    (0, _brandContainer2.default)();

    // activate asimov modals
    (0, _jquery2.default)('[data-modal-name]').modal();

    // activate asimov tooltips
    (0, _jquery2.default)('[data-tooltip]').tooltip();

    // automatically add CSRF tokens to ajax calls
    var token = (0, _jquery2.default)('meta[name="csrf-token"]').attr('content');

    (0, _jquery2.default)(document).ajaxSend(function (elm, xhr, s) {
        if (token && s && (s.type === 'POST' || s.type === 'DELETE' || s.type === 'PUT')) {
            xhr.setRequestHeader('X-Csrf-Token', token);
        }
    });

    // globalnav
    var dataNode = document.getElementById('globalnav-data');
    var appNode = document.querySelector('[data-globalnav-notifications-dropdown]');

    // appNode only present for logged in users
    if (dataNode && appNode) {
        var _JSON$parse = JSON.parse(dataNode.textContent),
            locale = _JSON$parse.locale;

        (0, _globalnav2.default)(appNode, locale);
    }
});

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _deprecated = __webpack_require__(25);

var _deprecated2 = _interopRequireDefault(_deprecated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pill = function (_React$Component) {
    _inherits(Pill, _React$Component);

    function Pill() {
        _classCallCheck(this, Pill);

        return _possibleConstructorReturn(this, (Pill.__proto__ || Object.getPrototypeOf(Pill)).apply(this, arguments));
    }

    _createClass(Pill, [{
        key: 'render',
        value: function render() {
            var variations = this.props.variations.slice();

            if (this.props.type) {
                // Add type as first variation
                (0, _deprecated2.default)('Pill:type is deprecated, prefer variations={[\'' + this.props.type + '\']}');
                variations.unshift(this.props.type);
            }

            if (variations.length === 0) {
                // This is required because we've removed the default value for type.
                // TODO: Remove this, when removing type prop.
                variations.push('info');
            }

            if (this.props.sizeVariation) {
                (0, _deprecated2.default)('Pill:sizeVariation is deprecated, prefer variations={[\'' + this.props.sizeVariation + '\']}');
                variations.push(this.props.sizeVariation);
            }

            var classes = (0, _app.getComponentClasses)('pill', variations);

            return _react2.default.createElement(
                'span',
                { className: classes, title: this.props.title },
                this.props.children
            );
        }
    }]);

    return Pill;
}(_react2.default.Component);

exports.default = Pill;


Pill.propTypes = {
    title: _propTypes2.default.string,
    variations: _propTypes2.default.array,
    sizeVariation: _propTypes2.default.oneOf(['small', 'tiny']),
    type: _propTypes2.default.oneOf(['notification', 'info', 'callout', 'success'])
};

Pill.defaultProps = {
    title: '',
    variations: [],
    sizeVariation: null
};

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Icon = function (_React$Component) {
    _inherits(Icon, _React$Component);

    function Icon() {
        _classCallCheck(this, Icon);

        return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
    }

    _createClass(Icon, [{
        key: 'render',
        value: function render() {
            var classes = (0, _app.getComponentClasses)('icon', this.props.variations);

            return _react2.default.createElement(
                'span',
                { className: classes },
                this.props.children
            );
        }
    }]);

    return Icon;
}(_react2.default.Component);

exports.default = Icon;


Icon.propTypes = {
    variations: _propTypes2.default.array
};

Icon.defaultProps = {
    variations: []
};

/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(914);
var invariant = __webpack_require__(915);
var ReactPropTypesSecret = __webpack_require__(917);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _core = __webpack_require__(161);

var _core2 = _interopRequireDefault(_core);

var _mediaQueryLabel = __webpack_require__(930);

var _mediaQueryLabel2 = _interopRequireDefault(_mediaQueryLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pluginName = 'mediaQueryLabel',
    defaults = {};

function build(options, elem) {
    var obj = new _mediaQueryLabel2.default().init(options, elem);

    // Public API

    return {
        is: function is(breakpoint) {
            return obj.is(breakpoint);
        },
        get: function get() {
            return obj.get();
        }
    };
}

// Plugin definition
//
_jquery2.default.fn[pluginName] = function (options) {
    return this.each(function () {
        if (!_jquery2.default.data(this, pluginName)) {
            var opts = _core2.default.mergeElementData((0, _jquery2.default)(this), pluginName, _jquery2.default.extend(true, {}, defaults, options));

            _jquery2.default.data(this, pluginName, build(opts, this));
        }
    });
};

/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _onmediaquery = __webpack_require__(931);

var _onmediaquery2 = _interopRequireDefault(_onmediaquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MediaQueryLabel = function MediaQueryLabel() {};

MediaQueryLabel.prototype.init = function (options, elem) {
    this.elem = elem;
    this.$elem = (0, _jquery2.default)(elem);

    this.options = options;

    this._bindEvents();

    return this;
};

MediaQueryLabel.prototype.is = function (breakpoint) {
    return this.get() === breakpoint;
};

MediaQueryLabel.prototype.get = function () {
    return (0, _jquery2.default)('html').attr('data-media-query-breakpoint');
};

MediaQueryLabel.prototype._bindEvents = function () {
    // Add queryable DOM property
    (0, _jquery2.default)(document).on('media-query:match', function (e, data) {
        if ((0, _jquery2.default)('html').length) {
            (0, _jquery2.default)('html').attr('data-media-query-breakpoint', data);
        }
    });

    (0, _jquery2.default)(document).ready(function () {
        _onmediaquery2.default.init([{
            context: '*',
            match: function match(breakpoint) {
                (0, _jquery2.default)(document).trigger('media-query:match', breakpoint);
            },
            unmatch: function unmatch(breakpoint) {
                (0, _jquery2.default)(document).trigger('media-query:unmatch', breakpoint);
            }
        }]);
    });
};

exports.default = MediaQueryLabel;

/***/ }),

/***/ 931:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * onMediaQuery
 * http://springload.co.nz/love-the-web/
 *
 * Copyright 2012, Springload
 * Released under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Date: Fri 24 October, 2012
 */

var mq = {};

/**
 * Initialises the MQ object and sets the initial media query callbacks
 * @returns Void(0)
 */
mq.init = function (query_array) {

    // Container for all callbacks registered with the plugin
    this.callbacks = [];
    this.context = ''; //current active query
    this.new_context = ''; //current active query to be read inside callbacks, as this.context won't be set when they're called!

    if (typeof query_array !== 'undefined') {
        for (var i = 0; i < query_array.length; i++) {
            var r = this.addQuery(query_array[i]);
        }
    }

    // Add a listener to the window.resize event, pass mq/self as the scope.
    this.addEvent(window, 'resize', mq.listenForChange, mq);

    // Figure out which query is active on load.
    this.listenForChange();
};

/**
 * Binds to the window.onResize and checks for media query changes
 * @returns Void(0)
 */
mq.listenForChange = function () {
    var query_string, properties;

    // Get the value of html { font-family } from the element style.
    if (document.documentElement.currentStyle) {
        query_string = document.documentElement.currentStyle["fontFamily"];
    }

    if (window.getComputedStyle) {
        properties = window.getComputedStyle(document.body, ':after');
        if ('getCSSPropertyValue' in properties) query_string = properties.getCSSPropertyValue("content").cssText;else query_string = properties.getPropertyValue("content");
        query_string.replace(/^("+)|("+)$/g, '');
    }

    // No support for CSS enumeration? Return and avoid errors.
    if (query_string === null) return;

    // Android browsers place a "," after an item in the font family list.
    // Most browsers either single or double quote the string.
    query_string = query_string.replace(/['",]/g, '');

    if (query_string !== this.context) {
        this.new_context = query_string;
        this.triggerCallbacks(this.context, 'unmatch');
        this.triggerCallbacks(this.new_context, 'match');
    }

    this.context = this.new_context;
};

/**
 * Attach a new query to test.
 * @param query_object {
 *     context: ['some_media_query','some_other_media_query'],
 *     call_for_each_context: true,
 *     callback: function() {
 *         //something awesome
 *     }
 * }
 * @returns A reference to the query_object that was added
 */
mq.addQuery = function (query_object) {
    if (query_object === null || query_object === undefined) return;

    this.callbacks.push(query_object);

    // If the context is passed as a string, turn it into an array (for unified approach elsewhere in the code)
    if (typeof query_object.context == "string") {
        query_object.context = [query_object.context];
    }

    // See if "call_for_each_context" is set, if not, set a default (for unified approach elsewhere in the code)
    if (typeof query_object.call_for_each_context !== "boolean") {
        query_object.call_for_each_context = true; // Default
    }

    // Fire the added callback if it matches the current context
    if (this.context !== '' && this._inArray(this.context, query_object.context)) {
        query_object.match();
    }

    return this.callbacks[this.callbacks.length - 1];
};

/**
 * Remove a query_object by reference.
 * @returns Void(0)
 */
mq.removeQuery = function (query_object) {
    if (query_object === null || query_object === undefined) return;

    var match = -1;

    while ((match = mq._indexOf(query_object, this.callbacks)) > -1) {
        this.callbacks.splice(match, 1);
    }
};

/**
 * Loop through the stored callbacks and execute
 * the ones that are bound to the current context.
 * @returns Void(0)
 */
mq.triggerCallbacks = function (size, key) {
    var i, callback_function, call_for_each_context;

    for (i = 0; i < this.callbacks.length; i++) {

        // Don't call for each context?
        if (this.callbacks[i].call_for_each_context === false) {
            if (key === 'match' && this._inArray(this.context, this.callbacks[i].context) || key === 'unmatch' && this._inArray(this.new_context, this.callbacks[i].context)) {
                // Was previously called, and we don't want to call it for each context
                continue;
            }
        }

        callback_function = this.callbacks[i][key];
        if (this._inArray(size, this.callbacks[i].context) && callback_function !== undefined) {
            callback_function();
        }

        if (this._inArray('*', this.callbacks[i].context) && callback_function !== undefined) {
            callback_function(size);
        }
    }
};

/**
 * Swiss Army Knife event binding, in lieu of jQuery.
 * @returns Void(0)
 */
mq.addEvent = function (elem, type, eventHandle, eventContext) {
    if (elem === null || elem === undefined) return;
    // If the browser supports event listeners, use them.
    if (elem.addEventListener) {
        elem.addEventListener(type, function () {
            eventHandle.call(eventContext);
        }, false);
    } else if (elem.attachEvent) {
        elem.attachEvent("on" + type, function () {
            eventHandle.call(eventContext);
        });

        // Otherwise, replace the current thing bound to on[whatever]! Consider refactoring.
    } else {
        elem["on" + type] = function () {
            eventHandle.call(eventContext);
        };
    }
};

/**
 * Function to return the mediaquery's previous context
 * @returns String returns the current mediaquery's context
 */
mq.getPreviousContext = function () {
    return this.context;
};

/**
 * Function to return the mediaquery's current context
 * @returns String returns the current mediaquery's context
 */
mq.getContext = function () {
    return this.new_context;
};

/**
 * Internal helper function that checks wether "needle" occurs in "haystack"
 * @param needle Mixed Value to look for in haystack array
 * @param haystack Array Haystack array to search in
 * @returns Boolan True if the needle occurs, false otherwise
 */
mq._inArray = function (needle, haystack) {
    var length = haystack.length;
    for (var i = 0; i < length; i++) {
        if (haystack[i] == needle) return true;
    }
    return false;
};

/**
 * IE8 do not supports Array.properties.indexOf
 * copy from jQuery.
 * in lieu of jQuery.
 * @returns int
 */
mq._indexOf = function (elem, arr, i) {
    var len;
    if (arr) {
        if (arr.indexOf) {
            return arr.indexOf(elem, i);
        }

        len = arr.length;
        i = i ? i < 0 ? Math.max(0, len + i) : i : 0;

        for (; i < len; i++) {
            // Skip accessing in sparse arrays
            if (i in arr && arr[i] === elem) {
                return i;
            }
        }
    }

    return -1;
};

// Expose the functions.
exports.default = mq;

/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _core = __webpack_require__(161);

var _core2 = _interopRequireDefault(_core);

var _offCanvas = __webpack_require__(936);

var _offCanvas2 = _interopRequireDefault(_offCanvas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pluginName = 'offCanvas',
    defaults = {
    'name': '',
    'variation': 'left'
};

function build(options, elem) {
    var obj = new _offCanvas2.default().init(options, elem);

    return {
        toggle: function toggle() {
            if (obj.isOpen()) {
                obj.close();
            } else {
                obj.open();
            }

            return this;
        }
    };
}

// Plugin definition

_jquery2.default.fn[pluginName] = function (options) {
    return this.each(function () {
        if (!_jquery2.default.data(this, pluginName)) {
            var opts = _core2.default.mergeElementData((0, _jquery2.default)(this), 'oc', _jquery2.default.extend(true, {}, defaults, options));

            _jquery2.default.data(this, pluginName, build(opts, this));
        }
    });
};

/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(937);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OffCanvas = function OffCanvas() {};

OffCanvas.prototype.init = function (options, elem) {
    this.elem = elem;
    this.$elem = (0, _jquery2.default)(elem);

    this.options = options;
    this.isActive = false;

    this._bindEvents(this.options, this.$elem);

    return this;
};

OffCanvas.prototype.isOpen = function (name) {
    return this.isActive;
};

OffCanvas.prototype.close = function (name) {
    var that = this,
        $canvas = that._getCanvas(name),
        $content = (0, _jquery2.default)('[data-oc-content=' + name + ']');

    // transitionEnd won't fire for zero second transitions, which we are using
    // for old Safari's and IE. This manually checks for this case, and closes the off-canvas immediately.
    // http://whoknew.dk/transitionend-will-not-fire-with-transition-duration-zero-481.htm

    var durationIsZero = $canvas.css('-webkit-transition-duration') === '0s' || $canvas.css('transition-duration') === '0s';

    if (durationIsZero) {
        that._close($canvas, $content);
    } else {
        $canvas.transitionEnd(function () {
            that._close($canvas, $content);
        });
    }

    (0, _jquery2.default)(document).trigger('oc:change', [$canvas, 'close']);

    $canvas.removeAttr('data-oc-state');
};

OffCanvas.prototype.open = function (name) {
    var that = this,
        $canvas = that._getCanvas(name),
        $content = (0, _jquery2.default)('[data-oc-content=' + name + ']'),
        variation = $content.attr('data-oc-variation');

    // set variation
    $canvas.attr('data-oc-variation', variation);

    // animate
    $canvas.attr('data-oc-state', 'active');
    $content.attr('data-oc-state', 'active');

    // add close trigger
    $canvas.one('click', function (e) {
        if (that._getTriggers(name).filter((0, _jquery2.default)(e.target)).length === 0) {
            that.close(name);
        }
    });

    this.isActive = true;

    (0, _jquery2.default)(document).trigger('oc:change', [$canvas, 'open']);

    return this;
};

OffCanvas.prototype._bindEvents = function (options, $element) {
    var that = this;

    _jquery2.default.each(options.name.split(' '), function (i, name) {
        $element.on('click', '[data-oc-trigger=' + name + ']', function (e) {
            var $canvas = that._getCanvas(name),
                $content = that._getContent(name);

            // cache the variation info
            $content.attr('data-oc-variation', $content.attr('data-oc-variation') || that.options.variation);

            // animation triggers
            if (that.isOpen()) {
                that.close(name);
            } else {
                that.open(name);
            }

            return false;
        });
    });
};

OffCanvas.prototype._getContent = function (name) {
    return (0, _jquery2.default)('[data-oc-canvas=' + name + ']');
};

OffCanvas.prototype._getCanvas = function (name) {
    return (0, _jquery2.default)('[data-oc-canvas~=' + name + ']');
};

OffCanvas.prototype._getTriggers = function (name) {
    return (0, _jquery2.default)('[data-oc-trigger~=' + name + ']');
};

OffCanvas.prototype._close = function ($canvas, $content) {
    $content.removeAttr('data-oc-state');
    $canvas.removeAttr('data-oc-variation');

    this.isActive = false;
};

exports.default = OffCanvas;

/***/ }),

/***/ 937:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
// ============================================================

function transitionEnd() {
    var name,
        el = document.createElement('asimov'),
        transEndEventNames = {
        'WebkitTransition': 'webkitTransitionEnd',
        'MozTransition': 'transitionend',
        'OTransition': 'oTransitionEnd otransitionend',
        'transition': 'transitionend'
    };

    for (name in transEndEventNames) {
        if (el.style[name] !== undefined) {
            return {
                end: transEndEventNames[name]
            };
        }
    }
}

_jquery2.default.fn.transitionEnd = function (callback) {
    if (_jquery2.default.support.transition) {
        (0, _jquery2.default)(this).one(_jquery2.default.support.transition.end, callback);
    } else {
        callback.call((0, _jquery2.default)(this));
    }

    return this;
};

(0, _jquery2.default)(function () {
    _jquery2.default.support.transition = transitionEnd();
});

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    small: [0, 599],
    medium: [600, 899],
    normal: [900, 1299],
    large: [1300, null]
};

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(3);
var asimov = __webpack_require__(161).default;
var PromoBar = __webpack_require__(941);

var pluginName = 'promoBar';
var promoBars = {};
var defaults = {
    cookieName: '',
    cookieDays: 1,
    cookiePrefix: '',
    dismissSelector: '[data-promo-bar-dismiss]'
};

function build(options, elem) {

    var obj = new PromoBar().init(options, elem);

    // Public API
    return {

        show: function show() {
            obj.show();
            return this;
        },

        hide: function hide() {
            obj.hide();
            return this;
        }

    };
}

// Plugin definition
$.fn[pluginName] = function (options) {
    return this.each(function () {
        if (!$.data(this, pluginName)) {
            var opts = asimov.mergeElementData($(this), pluginName, $.extend(true, {}, defaults, options));

            $.data(this, pluginName, build(opts, this));
        }
    });
};

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var set = function set(name, value, days) {
    var date,
        expires = '';

    if (days) {
        date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
};

var get = function get(c_name) {
    var c_start, c_end;

    if (document.cookie.length > 0) {
        c_start = document.cookie.indexOf(c_name + '=');
        if (c_start !== -1) {
            c_start = c_start + c_name.length + 1;
            c_end = document.cookie.indexOf(';', c_start);
            if (c_end === -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return '';
};

module.exports = {
    set: set,
    get: get
};

/***/ }),

/***/ 941:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(493);
var $ = __webpack_require__(3);
var Cookie = __webpack_require__(940);

var PromoBar = function PromoBar() {};

PromoBar.prototype = {

    init: function init(options, el) {
        this.$el = $(el);

        // Prepare options
        this.options = options;
        this.options.endpoint = this.$el.data('promoBarEndpoint') || null;
        this.options.cookieName = this.$el.data('promoBarName') || '';

        // Setup static or async promo-bar
        if (this.options.endpoint) {
            this.setupAsyncPromoBar();
        } else {
            this.setupStaticPromoBar();
        }
    },

    setupAsyncPromoBar: function setupAsyncPromoBar() {
        this.getMessage();
    },

    setupStaticPromoBar: function setupStaticPromoBar() {
        this.attachEvents();
    },

    getMessage: function getMessage() {
        $.getJSON(this.options.endpoint, this.processMessageResponse.bind(this));
    },

    processMessageResponse: function processMessageResponse(data) {
        if (data.name != null) {
            this.name = data.name;
            this.options.cookieDays = data.cookieExpiry || this.options.cookieDays;
            this.options.cookieName = data.name;
            this.$el.attr('data-promo-bar-name', data.name);
            this.$el.html(data.content);
            this.attachEvents();
            this.show();
        }
    },

    attachEvents: function attachEvents() {
        this.$el.find(this.options.dismissSelector).on('click', function (e) {
            e.preventDefault();
            this.hide();
            this.setSeenCookie();
        }.bind(this));
    },

    show: function show() {
        this.$el.removeAttr('data-hidden');
        if (typeof this.options.onShow == 'function') {
            this.options.onShow(this);
        }
        window.dispatchEvent(new CustomEvent('promo-bar-show'));
    },

    hide: function hide() {
        this.$el.attr('data-hidden', '');
        if (typeof this.options.onHide == 'function') {
            this.options.onHide(this);
        }
        window.dispatchEvent(new CustomEvent('promo-bar-hide'));
    },

    setSeenCookie: function setSeenCookie(fast) {
        Cookie.set(this.options.cookieName, 1, this.options.cookieDays);
    }

};

module.exports = PromoBar;

/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var role = (0, _jquery2.default)('[data-globalnavui-userrole]').data('globalnavui-userrole') || 'logged-out';
    var dropdowns = [];

    _asyncMenu2.default.attachTo(document, {
        needsInitialData: ['contest-holder', 'designer'].some(function (item) {
            return item === role;
        })
    });

    _messagesMenu2.default.attachTo('[data-globalnavui]', {
        key: 'messages',
        content: '[data-globalnavui-messages]',
        detachedDropdown: '[data-globalnavui-messages-detached-dropdown]',
        offCanvasMenuItem: '[data-globalnavui-messages-off-canvas-menu-item]',
        countContainer: '[data-globalnavui-messages-count-container]',
        link: '[data-globalnavui-messages-link]',
        count: '[data-globalnavui-messagecount]'
    });

    _loginRedirect2.default.attachTo('[data-globalnavui]');

    (0, _jquery2.default)('[data-oc-name]').offCanvas();

    (0, _jquery2.default)('[data-global-nav-detached-dropdown]').each(function (i, el) {
        dropdowns.push(new _detachedDropdown2.default((0, _jquery2.default)(el)));
    }.bind(this));

    (0, _jquery2.default)('[data-promo-bar]').promoBar({
        onShow: function onShow(elem) {
            (0, _platform.trackEvent)('Viewed Notice Bar', {
                notice_bar_name: elem.name
            });
            (0, _platform.trackLink)(elem.$el.find('a').not('[data-promo-bar-dismiss]').get(), 'Clicked Notice Bar Link', {
                notice_bar_name: elem.name
            });
        }
    });

    (0, _jquery2.default)('[data-global-nav-tooltip]').tooltip();

    // Use link elements for interaction instead of clickable spans

    (0, _jquery2.default)('[data-no-link]').on('click', function (e) {
        // Middle click, cmd click, and ctrl click should open
        // links in a new tab as normal.
        if (e.which > 1 || e.metaKey) {
            return true;
        } else {
            e.preventDefault();
        }
    });

    // Init admin controls if available
    if ((0, _jquery2.default)('[data-admin-bar]').length > 0) {
        (0, _jquery2.default)('[data-admin-bar]').detach().prependTo('body');
        _userSwitcher2.default.attachTo('[data-user-switcher]');
        _adminBar2.default.attachTo('[data-admin-bar]');
        _adminBarToggle2.default.attachTo('[data-admin-bar-toggle]');
        _offsetGlobalNav2.default.attachTo(document.body);
        _bugReporter2.default.attachTo('[data-admin-bar-bug-reporter]');
    }
};

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

var _adminBarToggle = __webpack_require__(945);

var _adminBarToggle2 = _interopRequireDefault(_adminBarToggle);

var _adminBar = __webpack_require__(946);

var _adminBar2 = _interopRequireDefault(_adminBar);

var _loginRedirect = __webpack_require__(948);

var _loginRedirect2 = _interopRequireDefault(_loginRedirect);

var _asyncMenu = __webpack_require__(944);

var _asyncMenu2 = _interopRequireDefault(_asyncMenu);

var _messagesMenu = __webpack_require__(949);

var _messagesMenu2 = _interopRequireDefault(_messagesMenu);

var _offsetGlobalNav = __webpack_require__(951);

var _offsetGlobalNav2 = _interopRequireDefault(_offsetGlobalNav);

var _userSwitcher = __webpack_require__(952);

var _userSwitcher2 = _interopRequireDefault(_userSwitcher);

var _bugReporter = __webpack_require__(947);

var _bugReporter2 = _interopRequireDefault(_bugReporter);

var _detachedDropdown = __webpack_require__(220);

var _detachedDropdown2 = _interopRequireDefault(_detachedDropdown);

var _platform = __webpack_require__(975);

__webpack_require__(161);

__webpack_require__(935);

__webpack_require__(939);

__webpack_require__(492);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(5);

function AsyncMenu() {
    this.attributes({
        needsInitialData: false,
        endpoint: '/api/global-nav/v2/messages.json'
    });

    this.menus = [{
        key: 'messages',
        unseenCount: 'unseenMessageCount',
        seenEndpoint: 'messagesSeenEndpoint'
    }];

    this.after('initialize', function () {
        this.on(document, 'brandContainer.ui.needsAllData', this.fetchData);
        this.on(document, 'brandContainer.ui.asyncMenuSeen', this.handleMenuSeen);

        if (this.attr.needsInitialData) {
            this.trigger('brandContainer.ui.needsAllData');
        }
    });

    this.fetchData = function () {
        // Turns out this never worked in IE9 due to lack of cors support.
        // This appears to fix it, but need to investigate impact
        // See http://stackoverflow.com/questions/10232017/ie9-jquery-ajax-with-cors-returns-access-is-denied/10232313#10232313
        $.support.cors = true;

        $.ajax({
            url: this.attr.endpoint,
            dataType: 'json',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            this.processResponse(data);
        }.bind(this));
    };

    this.processResponse = function (data) {
        this.menus.forEach(function (menu) {
            this.trigger('brandContainer.data.asyncMenuData', {
                key: menu.key,
                content: data[menu.key],
                unseenCount: data[menu.unseenCount],
                seenEndpoint: data[menu.seenEndpoint]
            });
        }.bind(this));
    };

    this.handleMenuSeen = function (e, data) {
        $.ajax({
            url: data.endpoint,
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            }
        });
    };
};

exports.default = (0, _flightjs.component)(AsyncMenu);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(5);

function AdminBarToggle() {
    this.after('initialize', function () {
        this.on('click', this.triggerToggle);
        this.on(document, 'brandContainer.ui.adminBarShown', this.setActive);
        this.on(document, 'brandContainer.ui.adminBarHidden', this.setInactive);
    });

    this.triggerToggle = function () {
        this.trigger('brandContainer.ui.adminBarToggleRequested');
    };

    this.setActive = function () {
        this.$node.attr('data-active', true);
    };

    this.setInactive = function () {
        this.$node.removeAttr('data-active');
    };
};

exports.default = (0, _flightjs.component)(AdminBarToggle);

/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(5);

function AdminBar() {

    this.after('initialize', function () {
        this.on(document, 'brandContainer.ui.adminBarToggleRequested', this.toggleAdminBar);
        this.loadState();
    });

    this.showAdminBar = function () {
        this.$node.removeAttr('data-hidden');
        this.saveState();
        this.trigger('brandContainer.ui.adminBarShown', {});
    };

    this.hideAdminBar = function () {
        this.$node.attr('data-hidden', true);
        this.saveState();
        this.trigger('brandContainer.ui.adminBarHidden', {});
    };

    this.toggleAdminBar = function () {
        if (!this.$node.attr('data-hidden')) {
            this.hideAdminBar();
        } else {
            this.showAdminBar();
        }

        this.scrollToTop();
    };

    this.scrollToTop = function () {
        $('body').animate({ scrollTop: 0 }, 'fast');
    };

    this.saveState = function () {
        var state = this.$node.attr('data-hidden');
        if (state) {
            document.cookie = 'admin:bar=hide; path=/';
        } else {
            document.cookie = 'admin:bar=show; path=/';
        }
    };

    this.loadState = function () {
        if (!!~document.cookie.indexOf('admin:bar=hide')) {
            this.hideAdminBar();
        } else {
            this.showAdminBar();
        }
    };
};

exports.default = (0, _flightjs.component)(AdminBar);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(5);

function BugReporter() {
    this.attributes({
        'cardNameAttr': 'data-bug-report-card-name',
        'listIdAttr': 'data-bug-report-list-id',
        'reportActionTrigger': '[data-bug-report-action]',
        'reportWindowOffsetTop': 370,
        'reportWindowOffsetLeft': 250,
        'reportWindowWidth': 500,
        'reportWindowHeight': 600
    });

    this.after('initialize', function () {
        this.on('click', {
            reportActionTrigger: this.openCreateCardWindow
        });
    });

    this.openCreateCardWindow = function () {
        var listId = this.$node.attr(this.attr.listIdAttr) || '56e8e2aee74a708f2bab8641';
        var cardName = this.$node.attr(this.attr.cardNameAttr) || 'Bug report';
        var reportWindowProps = '';
        var reportWindowName = 'add-trello-card';
        var reportWindowURL = 'https://trello.com/add-card?';

        reportWindowURL += 'source=' + encodeURIComponent(window.location.href);
        reportWindowURL += '&mode=popup';
        reportWindowURL += '&url=' + encodeURIComponent(window.location.href);
        reportWindowURL += '&name=' + encodeURIComponent(cardName);
        reportWindowURL += '&idList=' + listId;

        reportWindowProps += 'width=' + this.attr.reportWindowWidth;
        reportWindowProps += ',height=' + this.attr.reportWindowWidth;
        reportWindowProps += ',left=' + (window.screenX + window.outerWidth / 2 - this.attr.reportWindowOffsetLeft);
        reportWindowProps += ',top=' + (window.screenY + window.outerHeight / 2 - this.attr.reportWindowOffsetTop);

        window.open(reportWindowURL, reportWindowName, reportWindowProps);
    };
};

exports.default = (0, _flightjs.component)(BugReporter);

/***/ }),

/***/ 948:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(5);

function LoginRedirect() {
    this.attributes({
        loginLinkSelector: '[data-globalnavui-loginlink]'
    });
    /**
     * Update the target component of the login url with the current
     * url. This is done on the front-end to improve cacheability.
     */
    this.after('initialize', function () {
        var $loginLink = this.select('loginLinkSelector');
        if ($loginLink.length) {
            var loginHref = $loginLink.attr('href');
            var currentUrl = encodeURIComponent(document.location.href);

            // Replace `return` parameter in direct-to-SSO link
            loginHref = loginHref.replace(/target=([^&]+)/, 'target=' + currentUrl);
            // Replace `from` parameter in simple `/login` link
            loginHref = loginHref.replace(/\bfrom=([^&]+)/, 'from=' + currentUrl);

            $loginLink.attr('href', loginHref);
        }
    });
}

exports.default = (0, _flightjs.component)(LoginRedirect);

/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _flightjs = __webpack_require__(5);

var _asyncMenu = __webpack_require__(950);

var _asyncMenu2 = _interopRequireDefault(_asyncMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _flightjs.component)(_asyncMenu2.default);

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    this.seenEndpoint = null;
    this.isMenuOpen = false;

    this.attributes({
        key: null,
        detachedDropdown: null,
        offCanvasMenuItem: null,
        content: null,
        link: null,
        countContainer: null,
        count: null
    });

    this.after('initialize', function () {
        this.on(document, 'brandContainer.data.asyncMenuData', this.updateMenu);

        this.on('click', {
            link: this.handleMenuOpen
        });

        // Fired by detachedDropdown
        this.on('closed', {
            detachedDropdown: this.handleMenuClose
        });
    });

    this.handleMenuOpen = function () {
        this.isMenuOpen = true;
        this.trigger('brandContainer.ui.asyncMenuSeen', {
            key: this.attr.key,
            endpoint: this.seenEndpoint
        });
    };

    this.handleMenuClose = function () {
        if (this.isMenuOpen) {
            this.updateCount(0);
            this.isMenuOpen = false;
        }
    };

    this.updateMenu = function (e, data) {
        if (this.attr.key !== data.key) {
            return;
        }

        this.select('content').html(data.content);
        this.trigger('uiNeedsTimeUpdate');
        this.updateCount(data.unseenCount);
        this.seenEndpoint = data.seenEndpoint;
    };

    this.updateCount = function (count) {
        var count = Number(count);

        if (count > 0) {
            this.select('count').html(count);
            this.select('countContainer').removeAttr('data-hidden');
            this.select('offCanvasMenuItem').addClass('menu__item__action--has-pill');
        } else {
            this.select('countContainer').fadeOut(200, function () {
                this.select('count').html(count);
                this.select('countContainer').attr('data-hidden', true);
                this.select('offCanvasMenuItem').removeClass('menu__item__action--has-pill');
            }.bind(this));
        }
    };
};

;

/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(5);

function OffsetGlobalNav() {
    this.attributes({
        'ocWrapper': '[data-globalnavui]',
        'offsetDataAttr': 'data-oc-offset-admin-bar'
    });

    this.after('initialize', function () {
        this.on(document, 'brandContainer.ui.adminBarShown', this.applyOffset);
        this.on(document, 'brandContainer.ui.adminBarHidden', this.removeOffset);
    });

    this.applyOffset = function () {
        this.select('ocWrapper').attr(this.attr.offsetDataAttr, true);
    };

    this.removeOffset = function () {
        this.select('ocWrapper').removeAttr(this.attr.offsetDataAttr);
    };
};

exports.default = (0, _flightjs.component)(OffsetGlobalNav);

/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(5);

function UserSwitcher() {

    this.defaultAttrs({
        radioSelector: 'input[type=radio][name=userid]'
    });

    this.after('initialize', function () {
        this.on(this.$node.select('radioSelector'), 'change', this.submitForm);
    });

    this.submitForm = function () {
        var $form = this.$node.closest('form');

        if (!this.$node.find('input[name="from"]').length) {
            $('<input>').attr({
                type: 'hidden',
                name: 'from'
            }).val(this.getFromUrl()).appendTo($form);
        }

        $form.submit();
    };

    this.getFromUrl = function () {
        return window.location.href;
    };
}

exports.default = (0, _flightjs.component)(UserSwitcher);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (appNode, locale) {
    _reactDom2.default.render(_react2.default.createElement(
        _reactIntl.IntlProvider,
        { locale: normalizeLocaleToPosixFormat(locale), messages: (0, _localeData.getTranslations)() },
        _react2.default.createElement(_onsiteNotifications2.default, {
            urls: _urls2.default
        })
    ), appNode);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(8);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _onsiteNotifications = __webpack_require__(970);

var _onsiteNotifications2 = _interopRequireDefault(_onsiteNotifications);

var _urls = __webpack_require__(971);

var _urls2 = _interopRequireDefault(_urls);

var _localeData = __webpack_require__(103);

var _reactIntl = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function normalizeLocaleToPosixFormat(locale) {
    return locale.replace('_', '-').toLowerCase();
}

/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.connectWebsocket = connectWebsocket;

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var maxRetries = 3;
var retries = 0;

function connectWebsocket(authUrl, onMessage) {
    if (typeof WebSocket === 'undefined') {
        return;
    }

    return _superagent2.default.get(authUrl).then(function (resp) {
        if (!resp.body || !resp.body.url) {
            throw new Error('No onsite notifications websocket URL found.');
        }
        initWebsocket(resp.body.url, authUrl, onMessage);
    }).catch(function (err) {
        retryConnectOnFailure(authUrl, onMessage);
    });
}

function initWebsocket(websocketUrl, authUrl, onMessage) {
    var websocket = new WebSocket(websocketUrl);
    websocket.onclose = function (e) {
        retryConnect(authUrl, onMessage);
    };
    websocket.onmessage = function (e) {
        var messages = e.data.split('\n');
        for (var i = 0; i < messages.length; i++) {
            var data = JSON.parse(messages[i]);
            onMessage(data);
        }
    };
}

function retryConnectOnFailure(authUrl, onMessage) {
    if (retries >= maxRetries) {
        return;
    }
    retries += 1;
    retryConnect(authUrl, onMessage);
}

function retryConnect(authUrl, onMessage) {
    // randomise reconnect delay between 200ms -> 5000ms
    var rand = Math.round(Math.random() * (5000 - 200)) + 200;
    setTimeout(function () {
        connectWebsocket(authUrl, onMessage);
    }, rand);
}

/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Desktop = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _breakpoints = __webpack_require__(938);

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _reactResponsive = __webpack_require__(1487);

var _reactResponsive2 = _interopRequireDefault(_reactResponsive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Desktop = exports.Desktop = function Desktop(_ref) {
    var children = _ref.children,
        values = _ref.values;

    return _react2.default.createElement(_reactResponsive2.default, {
        minWidth: _breakpoints2.default.normal[0],
        children: children,
        values: values
    });
};

/***/ }),

/***/ 965:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(479);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VIEWPORT_HEIGHT_PADDING = 50; // maintain this distance between bottom of container and viewport

var OnsiteNotificationsDropdown = function (_React$Component) {
    _inherits(OnsiteNotificationsDropdown, _React$Component);

    function OnsiteNotificationsDropdown(props) {
        _classCallCheck(this, OnsiteNotificationsDropdown);

        var _this = _possibleConstructorReturn(this, (OnsiteNotificationsDropdown.__proto__ || Object.getPrototypeOf(OnsiteNotificationsDropdown)).call(this, props));

        _this.contentNode = null;
        return _this;
    }

    _createClass(OnsiteNotificationsDropdown, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('click', this.props.onDocumentClick);
            this.calculateHeight();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this.props.onDocumentClick);
        }
    }, {
        key: 'getViewportHeight',
        value: function getViewportHeight() {
            return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        }
    }, {
        key: 'calculateHeight',
        value: function calculateHeight() {
            var rect = this.contentNode.getBoundingClientRect();
            var diff = this.getViewportHeight() - rect.bottom - VIEWPORT_HEIGHT_PADDING;

            if (diff < 0) {
                this.props.onViewportHeightAdjustment(diff);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                {
                    className: 'onsite-notifications__dropdown',
                    ref: function ref(n) {
                        return _this2.contentNode = n;
                    }
                },
                this.props.children,
                _react2.default.createElement('div', { className: 'onsite-notifications__tip' })
            );
        }
    }]);

    return OnsiteNotificationsDropdown;
}(_react2.default.Component);

exports.default = OnsiteNotificationsDropdown;


OnsiteNotificationsDropdown.propTypes = {
    onViewportHeightAdjustment: _propTypes2.default.func,
    onDocumentClick: _propTypes2.default.func,
    children: _propTypes2.default.node.isRequired
};

OnsiteNotificationsDropdown.defaultProps = {
    onViewportHeightAdjustment: function onViewportHeightAdjustment() {},
    onDocumentClick: function onDocumentClick() {}
};

/***/ }),

/***/ 966:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(479);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Pill = __webpack_require__(86);

var _Pill2 = _interopRequireDefault(_Pill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnsiteNotificationsIcon = function (_React$Component) {
    _inherits(OnsiteNotificationsIcon, _React$Component);

    function OnsiteNotificationsIcon(props) {
        _classCallCheck(this, OnsiteNotificationsIcon);

        var _this = _possibleConstructorReturn(this, (OnsiteNotificationsIcon.__proto__ || Object.getPrototypeOf(OnsiteNotificationsIcon)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(OnsiteNotificationsIcon, [{
        key: 'handleClick',
        value: function handleClick(e) {
            this.props.onClick(e);
        }
    }, {
        key: 'unreadCount',
        value: function unreadCount() {
            if (this.props.unreadCount === 0) {
                return null;
            }

            return _react2.default.createElement(
                'span',
                { className: 'top-level-nav__item__notification-counter' },
                _react2.default.createElement(
                    _Pill2.default,
                    { variations: ['notification', 'tiny'] },
                    this.props.unreadCount > 99 ? '99+' : this.props.unreadCount
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'a',
                {
                    href: this.props.urls.notifications,
                    onClick: this.handleClick,
                    onMouseEnter: this.props.onMouseEnter,
                    className: 'top-level-nav__item__link',
                    'data-onsite-notifications-toggle': true
                },
                _react2.default.createElement(
                    'div',
                    { className: 'top-level-nav__item__notification-icon icon--inline' },
                    this.unreadCount()
                )
            );
        }
    }]);

    return OnsiteNotificationsIcon;
}(_react2.default.Component);

exports.default = OnsiteNotificationsIcon;


OnsiteNotificationsIcon.propTypes = {
    urls: _propTypes2.default.object.isRequired,
    onClick: _propTypes2.default.func,
    onMouseEnter: _propTypes2.default.func,
    unreadCount: _propTypes2.default.number
};

OnsiteNotificationsIcon.defaultProps = {
    onClick: function onClick() {},
    onMouseEnter: function onMouseEnter() {},

    unreadCount: 0
};

/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(479);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _getComponentClasses = __webpack_require__(30);

var _getComponentClasses2 = _interopRequireDefault(_getComponentClasses);

var _RelativeTime = __webpack_require__(98);

var _RelativeTime2 = _interopRequireDefault(_RelativeTime);

var _Icon = __webpack_require__(9);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnsiteNotificationsListItem = function (_React$Component) {
    _inherits(OnsiteNotificationsListItem, _React$Component);

    function OnsiteNotificationsListItem() {
        _classCallCheck(this, OnsiteNotificationsListItem);

        return _possibleConstructorReturn(this, (OnsiteNotificationsListItem.__proto__ || Object.getPrototypeOf(OnsiteNotificationsListItem)).apply(this, arguments));
    }

    _createClass(OnsiteNotificationsListItem, [{
        key: 'thumbnail',
        value: function thumbnail() {
            if (!this.props.notification.thumbnailUrl) {
                return null;
            }

            return _react2.default.createElement('img', {
                className: 'onsite-notifications__list-item__thumbnail',
                src: this.props.notification.thumbnailUrl
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var notification = this.props.notification;

            var classes = (0, _classnames2.default)({
                'onsite-notifications__list-item': true,
                'onsite-notifications__list-item--read': notification.isRead
            });

            var iconClasses = (0, _getComponentClasses2.default)('onsite-notifications__icon', [notification.icon]);

            return _react2.default.createElement(
                'a',
                {
                    className: classes,
                    href: this.props.notification.destinationUrl
                },
                _react2.default.createElement(
                    'div',
                    { className: 'onsite-notifications__list-item__content' },
                    _react2.default.createElement('div', {
                        className: 'onsite-notifications__list-item__message',
                        dangerouslySetInnerHTML: { __html: notification.messageHtml }
                    }),
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'onsite-notifications__list-item__metadata'
                        },
                        _react2.default.createElement('span', { className: iconClasses }),
                        _react2.default.createElement(
                            'span',
                            { className: 'onsite-notifications__list-item__updated-at' },
                            _react2.default.createElement(_RelativeTime2.default, {
                                date: notification.lastActivityAt,
                                absoluteTimeFormat: 'long'
                            })
                        )
                    )
                ),
                this.thumbnail()
            );
        }
    }]);

    return OnsiteNotificationsListItem;
}(_react2.default.Component);

exports.default = OnsiteNotificationsListItem;


OnsiteNotificationsListItem.propTypes = {
    notification: _propTypes2.default.object.isRequired
};

/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(479);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spinner = __webpack_require__(21);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _onsiteNotificationsListItem = __webpack_require__(967);

var _onsiteNotificationsListItem2 = _interopRequireDefault(_onsiteNotificationsListItem);

var _onsiteNotificationsScrollable = __webpack_require__(969);

var _onsiteNotificationsScrollable2 = _interopRequireDefault(_onsiteNotificationsScrollable);

var _reactIntl = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnsiteNotificationsList = function (_React$Component) {
    _inherits(OnsiteNotificationsList, _React$Component);

    function OnsiteNotificationsList(props) {
        _classCallCheck(this, OnsiteNotificationsList);

        var _this = _possibleConstructorReturn(this, (OnsiteNotificationsList.__proto__ || Object.getPrototypeOf(OnsiteNotificationsList)).call(this, props));

        _this.handleMarkAllRead = _this.handleMarkAllRead.bind(_this);
        return _this;
    }

    _createClass(OnsiteNotificationsList, [{
        key: 'handleMarkAllRead',
        value: function handleMarkAllRead(e) {
            e.preventDefault();
            this.props.onMarkAllRead();
        }
    }, {
        key: 'notifications',
        value: function notifications() {
            var notifications = this.props.notifications;

            if (this.props.isLoading) {
                return _react2.default.createElement(
                    'div',
                    { className: 'onsite-notifications__spinner' },
                    _react2.default.createElement(_Spinner2.default, null)
                );
            }

            if (notifications.length === 0) {
                return _react2.default.createElement(
                    'div',
                    { className: 'onsite-notifications__message-none' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'No notifications found.', defaultMessage: 'No notifications found.' })
                );
            }

            return _react2.default.createElement(
                _onsiteNotificationsScrollable2.default,
                {
                    viewportHeightDiff: this.props.viewportHeightDiff
                },
                Object.keys(notifications).map(function (key) {
                    return _react2.default.createElement(_onsiteNotificationsListItem2.default, {
                        key: key,
                        notification: notifications[key]
                    });
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                {
                    className: 'onsite-notifications__list'
                },
                _react2.default.createElement(
                    'div',
                    { className: 'onsite-notifications__header' },
                    _react2.default.createElement(
                        'div',
                        { className: 'onsite-notifications__header__heading' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Notifications', defaultMessage: 'Notifications' })
                    )
                ),
                this.notifications(),
                _react2.default.createElement(
                    'div',
                    { className: 'onsite-notifications__footer' },
                    _react2.default.createElement(
                        'div',
                        { className: 'onsite-notifications__footer__see-all' },
                        _react2.default.createElement(
                            'a',
                            {
                                href: this.props.urls.notifications,
                                className: 'onsite-notifications__link'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'See all notifications', defaultMessage: 'See all notifications' })
                        )
                    ),
                    _react2.default.createElement(
                        'a',
                        {
                            href: '#',
                            className: 'onsite-notifications__link onsite-notifications__footer__mark-read',
                            onClick: this.handleMarkAllRead
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Mark all as read', defaultMessage: 'Mark all as read' })
                    )
                )
            );
        }
    }]);

    return OnsiteNotificationsList;
}(_react2.default.Component);

exports.default = OnsiteNotificationsList;


OnsiteNotificationsList.propTypes = {
    notifications: _propTypes2.default.array.isRequired,
    urls: _propTypes2.default.object.isRequired,
    onMarkAllRead: _propTypes2.default.func,
    viewportHeightDiff: _propTypes2.default.number,
    isLoading: _propTypes2.default.bool
};

OnsiteNotificationsList.defaultProps = {
    onMarkAllRead: function onMarkAllRead() {},

    isLoading: true
};

/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(479);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnsiteNotificationsScrollable = function (_React$Component) {
    _inherits(OnsiteNotificationsScrollable, _React$Component);

    function OnsiteNotificationsScrollable(props) {
        _classCallCheck(this, OnsiteNotificationsScrollable);

        var _this = _possibleConstructorReturn(this, (OnsiteNotificationsScrollable.__proto__ || Object.getPrototypeOf(OnsiteNotificationsScrollable)).call(this, props));

        _this.innerHeight = 'auto';
        _this.scrollableNode = null;
        _this.handleWheel = _this.handleWheel.bind(_this);
        return _this;
    }

    _createClass(OnsiteNotificationsScrollable, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.viewportHeightDiff !== this.props.viewportHeightDiff) {
                this.setInnerHeight(nextProps.viewportHeightDiff);
            }
        }
    }, {
        key: 'handleWheel',
        value: function handleWheel(e) {
            var node = this.scrollableNode;
            var scrollHeight = node.scrollHeight;
            var scrollTop = node.scrollTop;
            var clientHeight = node.clientHeight;
            var isDeltaPositive = e.deltaY > 0;

            if (this.isScrollingPreventable(scrollHeight, clientHeight) && (this.isScrollingAtTop(isDeltaPositive, scrollTop) || this.isScrollingAtBottom(isDeltaPositive, scrollTop, scrollHeight, clientHeight))) {
                e.preventDefault();
            }
        }
    }, {
        key: 'isScrollingPreventable',
        value: function isScrollingPreventable(scrollHeight, clientHeight) {
            // allow scrollable prevention when scrollable panel is large enough to have internal scrolling
            return scrollHeight > clientHeight;
        }
    }, {
        key: 'isScrollingAtTop',
        value: function isScrollingAtTop(isDeltaPositive, scrollTop) {
            return !isDeltaPositive && scrollTop === 0;
        }
    }, {
        key: 'isScrollingAtBottom',
        value: function isScrollingAtBottom(isDeltaPositive, scrollTop, scrollHeight, clientHeight) {
            return isDeltaPositive && scrollTop >= scrollHeight - clientHeight;
        }
    }, {
        key: 'setInnerHeight',
        value: function setInnerHeight(viewportHeightDiff) {
            var height = this.scrollableNode.offsetHeight + viewportHeightDiff;
            this.innerHeight = height > 0 ? height : 'auto';
        }
    }, {
        key: 'getStyles',
        value: function getStyles() {
            return {
                height: this.innerHeight
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'onsite-notifications__content-scroll' },
                _react2.default.createElement(
                    'div',
                    {
                        ref: function ref(node) {
                            return _this2.scrollableNode = node;
                        },
                        onWheel: this.handleWheel,
                        className: 'onsite-notifications__content-scroll__inner',
                        style: this.getStyles()
                    },
                    this.props.children
                )
            );
        }
    }]);

    return OnsiteNotificationsScrollable;
}(_react2.default.Component);

exports.default = OnsiteNotificationsScrollable;


OnsiteNotificationsScrollable.propTypes = {
    children: _propTypes2.default.node.isRequired,
    viewportHeightDiff: _propTypes2.default.number
};

/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(479);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(82);

var _lodash2 = _interopRequireDefault(_lodash);

var _onsiteNotificationsDropdown = __webpack_require__(965);

var _onsiteNotificationsDropdown2 = _interopRequireDefault(_onsiteNotificationsDropdown);

var _onsiteNotificationsIcon = __webpack_require__(966);

var _onsiteNotificationsIcon2 = _interopRequireDefault(_onsiteNotificationsIcon);

var _onsiteNotificationsList = __webpack_require__(968);

var _onsiteNotificationsList2 = _interopRequireDefault(_onsiteNotificationsList);

var _breakpoints = __webpack_require__(964);

var _onsiteNotificationCollection = __webpack_require__(972);

var _onsiteNotificationCollection2 = _interopRequireDefault(_onsiteNotificationCollection);

var _websocket = __webpack_require__(963);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _bugsnag = __webpack_require__(148);

var _bugsnag2 = _interopRequireDefault(_bugsnag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnsiteNotifications = function (_React$Component) {
    _inherits(OnsiteNotifications, _React$Component);

    function OnsiteNotifications(props) {
        _classCallCheck(this, OnsiteNotifications);

        var _this = _possibleConstructorReturn(this, (OnsiteNotifications.__proto__ || Object.getPrototypeOf(OnsiteNotifications)).call(this, props));

        _this.outerNode = null;
        _this.fetchNotificationsWithDebounceFunc = null;

        _this.state = {
            isActive: false,
            isLoading: true,
            notifications: [],
            unreadCount: 0,
            viewportHeightDiff: null
        };

        _this.handleIconClick = _this.handleIconClick.bind(_this);
        _this.handleIconMouseEnter = _this.handleIconMouseEnter.bind(_this);
        _this.onMarkAllRead = _this.onMarkAllRead.bind(_this);
        _this.onViewportHeightAdjustment = _this.onViewportHeightAdjustment.bind(_this);
        _this.onDocumentClick = _this.onDocumentClick.bind(_this);
        return _this;
    }

    _createClass(OnsiteNotifications, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            this.fetchNotificationsWithDebounceFunc = (0, _lodash2.default)(this.fetchNotifications, 1000, {
                leading: true,
                maxWait: 1500
            });

            (0, _websocket.connectWebsocket)(this.props.urls.notificationsWebsocketAuth, function (data) {
                if (data.type) {
                    if (data.type === 'unread-counter') {
                        _this2.setState(function () {
                            return { unreadCount: data.count };
                        });
                    }
                }
            });
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            if (this.outerNode && !this.outerNode.contains(e.target)) {
                this.deactivate();
            }
        }

        // Flag (pre-emptively) all notifications as read. We do not re-fetch from the server
        // as that would re-order/mutate the result set the user is viewing.
        // TODO handle api route failure

    }, {
        key: 'onMarkAllRead',
        value: function onMarkAllRead() {
            var readNotifications = this.state.notifications.map(function (notification) {
                return Object.assign({}, notification, { isRead: true });
            });
            this.setState(function () {
                return { notifications: readNotifications };
            });

            return _superagent2.default.post(this.props.urls.xhrMarkAllRead).end();
        }
    }, {
        key: 'fetchNotifications',
        value: function fetchNotifications() {
            var _this3 = this;

            this.setState({ isLoading: true });

            return _superagent2.default.get(this.props.urls.xhrFetchNotifications).then(function (resp) {
                var notifications = _onsiteNotificationCollection2.default.fromJSON(resp.body);
                if (!notifications) {
                    _bugsnag2.default.notify('GlobalnavMissingNotifications', 'Globalnav failed to fetch a valid notifications array.', {
                        'responseStatus': resp.status,
                        'responseError': resp.error,
                        'responseText': resp.text
                    });
                }

                _this3.setState(function () {
                    return {
                        isLoading: false,
                        notifications: notifications
                    };
                });
            });
        }
    }, {
        key: 'markReadCounter',
        value: function markReadCounter() {
            return _superagent2.default.post(this.props.urls.xhrMarkReadCounter).end();
        }
    }, {
        key: 'handleIconClick',
        value: function handleIconClick(e) {
            e.preventDefault();

            this.setState(function (prevState, props) {
                return {
                    isActive: !prevState.isActive,
                    viewportHeightDiff: prevState.isActive ? null : prevState.viewportHeightDiff
                };
            });

            this.markReadCounter();
        }
    }, {
        key: 'handleIconMouseEnter',
        value: function handleIconMouseEnter() {
            if (!this.state.isActive) {
                this.fetchNotificationsWithDebounceFunc();
            }
        }
    }, {
        key: 'deactivate',
        value: function deactivate() {
            this.setState(function () {
                return {
                    isActive: false,
                    viewportHeightDiff: null
                };
            });
        }
    }, {
        key: 'onViewportHeightAdjustment',
        value: function onViewportHeightAdjustment(viewportHeightDiff) {
            this.setState({ viewportHeightDiff: viewportHeightDiff });
        }
    }, {
        key: 'icon',
        value: function icon() {
            var _this4 = this;

            return _react2.default.createElement(
                _breakpoints.Desktop,
                { values: this.props.desktopUiValues },
                function (isDesktopUI) {
                    if (isDesktopUI) {
                        return _react2.default.createElement(_onsiteNotificationsIcon2.default, {
                            urls: _this4.props.urls,
                            onClick: _this4.handleIconClick,
                            onMouseEnter: _this4.handleIconMouseEnter,
                            unreadCount: _this4.state.unreadCount
                        });
                    } else {
                        return _react2.default.createElement(_onsiteNotificationsIcon2.default, {
                            urls: _this4.props.urls,
                            unreadCount: _this4.state.unreadCount
                        });
                    }
                }
            );
        }
    }, {
        key: 'dropdown',
        value: function dropdown() {
            if (!this.state.isActive) {
                return null;
            }

            return _react2.default.createElement(
                _onsiteNotificationsDropdown2.default,
                {
                    onViewportHeightAdjustment: this.onViewportHeightAdjustment,
                    onDocumentClick: this.onDocumentClick
                },
                _react2.default.createElement(_onsiteNotificationsList2.default, {
                    notifications: this.state.notifications,
                    urls: this.props.urls,
                    onMarkAllRead: this.onMarkAllRead,
                    viewportHeightDiff: this.state.viewportHeightDiff,
                    isLoading: this.state.isLoading
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            return _react2.default.createElement(
                'div',
                {
                    className: 'onsite-notifications',
                    ref: function ref(node) {
                        return _this5.outerNode = node;
                    }
                },
                this.icon(),
                this.dropdown()
            );
        }
    }]);

    return OnsiteNotifications;
}(_react2.default.Component);

exports.default = OnsiteNotifications;


OnsiteNotifications.propTypes = {
    urls: _propTypes2.default.object.isRequired,
    desktopUiValues: _propTypes2.default.object
};

OnsiteNotifications.defaultProps = {
    desktopUiValues: {}
};

/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    xhrFetchNotifications: '/notifications/xhr/onsite',
    xhrMarkReadCounter: '/notifications/xhr/onsite/mark-read-counter',
    xhrMarkAllRead: '/notifications/xhr/onsite/mark-all-read',
    notifications: '/notifications',
    notificationsWebsocketAuth: '/notifications/ws/auth'
};

/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _onsiteNotification = __webpack_require__(973);

var _onsiteNotification2 = _interopRequireDefault(_onsiteNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { fromJSON: fromJSON };

// Translate from HAL API to local data structure

function fromJSON(json) {
    if (!json) {
        return null;
    }

    return json._embedded.notifications.map(_onsiteNotification2.default.fromJSON);
}

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propertyOrNull = __webpack_require__(17);

var _propertyOrNull2 = _interopRequireDefault(_propertyOrNull);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { fromJSON: fromJSON };

// Translate from HAL API to local data structure

function fromJSON(json) {
    if (!json) {
        return null;
    }

    var data = {
        messageHtml: (0, _propertyOrNull2.default)(json, 'messageHtml'),
        isRead: (0, _propertyOrNull2.default)(json, 'isRead'),
        icon: (0, _propertyOrNull2.default)(json, 'icon'),
        thumbnailUrl: (0, _propertyOrNull2.default)(json, 'thumbnailUrl'),
        destinationUrl: (0, _propertyOrNull2.default)(json, 'destinationUrl'),
        lastActivityAt: (0, _propertyOrNull2.default)(json, 'lastActivityAt'),
        links: {
            self: (0, _propertyOrNull2.default)(json._links.self, 'href')
        }
    };

    return data;
}

/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bugsnag = __webpack_require__(148);

Object.defineProperty(exports, 'bugsnag', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bugsnag).default;
  }
});

var _trackEvent = __webpack_require__(66);

Object.defineProperty(exports, 'trackEvent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_trackEvent).default;
  }
});

var _trackLink = __webpack_require__(976);

Object.defineProperty(exports, 'trackLink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_trackLink).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
// Segment analytics link tracking that includes experiment data.
// The Segment implementation allows a single element or an Array to be passed
// in, so we're keeping this as close as possible to this.
// See: https://segment.com/docs/sources/website/analytics.js/#track-link

exports.default = trackLink;

var _dom = __webpack_require__(416);

function trackLink(trackable, event) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!trackable) return this;

    if (trackable instanceof global.Array) {
        trackable.forEach(function (el) {
            return setupTrackLink(el, event, params);
        });

        return this;
    } else if (trackable instanceof window.NodeList) {
        for (var i = 0; i < trackable.length; i++) {
            setupTrackLink(trackable[i], event, params);
        }

        return this;
    } else {
        setupTrackLink(trackable, event, params);

        return this;
    }
}

function setupTrackLink(element, event, params) {
    var trackParams = window.trackParams || {};

    params = _extends({
        url: window.location.href,
        target_path: (0, _dom.getLinkTargetPath)(element),
        target_url: (0, _dom.getLinkTargetUrl)(element, window.location)
    }, trackParams, params);

    if (false) {
        element.addEventListener('click', function () {
            console.info('Track link: "%s": %o', event, params); // eslint-disable-line no-console
        });
    }

    if (window.analytics) {
        window.analytics.trackLink(element, event, params);
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12)))

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
// ============================================================

function transitionEnd() {
    var name,
        el = document.createElement('asimov'),
        transEndEventNames = {
        'WebkitTransition': 'webkitTransitionEnd',
        'MozTransition': 'transitionend',
        'OTransition': 'oTransitionEnd otransitionend',
        'transition': 'transitionend'
    };

    for (name in transEndEventNames) {
        if (el.style[name] !== undefined) {
            return {
                end: transEndEventNames[name]
            };
        }
    }
}

_jquery2.default.fn.transitionEnd = function (callback) {
    if (_jquery2.default.support.transition) {
        (0, _jquery2.default)(this).one(_jquery2.default.support.transition.end, callback);
    } else {
        callback.call((0, _jquery2.default)(this));
    }

    return this;
};

(0, _jquery2.default)(function () {
    _jquery2.default.support.transition = transitionEnd();
});

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(6);

var _DateTimeToolTip = __webpack_require__(119);

var _DateTimeToolTip2 = _interopRequireDefault(_DateTimeToolTip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RelativeTime = function (_React$Component) {
    _inherits(RelativeTime, _React$Component);

    function RelativeTime() {
        _classCallCheck(this, RelativeTime);

        return _possibleConstructorReturn(this, (RelativeTime.__proto__ || Object.getPrototypeOf(RelativeTime)).apply(this, arguments));
    }

    _createClass(RelativeTime, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _DateTimeToolTip2.default,
                { date: this.props.date, format: this.props.absoluteTimeFormat },
                _react2.default.createElement(_reactIntl.FormattedRelative, { value: this.props.date })
            );
        }
    }]);

    return RelativeTime;
}(_react2.default.Component);

exports.default = RelativeTime;


RelativeTime.propTypes = {
    date: _propTypes2.default.any.isRequired,
    absoluteTimeFormat: _propTypes2.default.string
};

/***/ })

},[1527]);


// WEBPACK FOOTER //
// app/layout-c3d0e3e54071efb7524c.js